import CBVacancyCurrentActivityCard from "@/apps/tatar/cashBudget/views/portfolio/object/cards/vacancy/CBVacancyCurrentActivityCard";
import CBVacancyDistributionCard from "@/apps/tatar/cashBudget/views/portfolio/object/cards/vacancy/CBVacancyDistributionCard";
import CBVacancyHistoryCard from "@/apps/tatar/cashBudget/views/portfolio/object/cards/vacancy/CBVacancyHistoryCard";
import {
  CBVacancyWALE,
  CBVacancyWALT,
} from "@/apps/tatar/cashBudget/views/portfolio/object/cards/vacancy/CBVacancySingleValues";
import CBVacancySoonCard from "@/apps/tatar/cashBudget/views/portfolio/object/cards/vacancy/CBVacancySoonCard";
import i18n from "@/i18n";
import { BaseConstants, useSpecificConstants } from "@/redux/hooks";
import "./ObjectDetailVacancy.scss";
import { RentDataSection } from "./RentDataSection";

type PropsObject = {
  refId: string;
  assets: string[];
};
type Props = PropsObject;
const ObjectDetailVacancy = (props: Props) => {
  const vacancyConstants = useSpecificConstants<
    { serviceUrl: string; businessUnits: string[] } & BaseConstants
  >("app-vacancy");

  if (!vacancyConstants) {
    return (
      <div className={`__sub-text`}>
        {i18n.t(
          "Global.Labels.noPermission",
          "Sie haben nicht die Berechtigung diesen Bereich zu sehen"
        )}
      </div>
    );
  }
  return (
    <div className="object-vacancy">
      <div className="single-kpis">
        <div className="entry">
          <CBVacancyWALT referenceId={props.refId} objectIds={props.assets} />
        </div>

        <div className="entry">
          <CBVacancyWALE referenceId={props.refId} objectIds={props.assets} />
        </div>
      </div>
      <CBVacancyDistributionCard
        referenceId={props.refId}
        objectIds={props.assets}
        marginBottom={20}
      />

      {props.assets.length === 1 && (
        <RentDataSection objectId={props.assets[0]} />
      )}

      <CBVacancyHistoryCard
        referenceId={props.refId}
        objectIds={props.assets}
        marginBottom={20}
      />
      <CBVacancyCurrentActivityCard
        referenceId={props.refId}
        objectIds={props.assets}
        marginBottom={20}
      />
      <CBVacancySoonCard
        referenceId={props.refId}
        objectIds={props.assets}
        marginBottom={20}
      />
    </div>
  );
};
export default ObjectDetailVacancy;

//KPI
